









































































































import Vue from 'vue';
import Component from 'vue-class-component';
import IOption from '@/store/models/IOption';
import { DropdownInput, CheckBoxMultiInput, TextInput, RadioListInput } from '@/components/FormInputs/FormInputs';

@Component({
	name: 'ClaimView',
	components: {
		DropdownInput,
		CheckBoxMultiInput,
		TextInput,
		RadioListInput,
	}
})

export default class ClaimView extends Vue {
	private isLoading: boolean = true;
	public rights: string[] = [];

	public allTypesOfRightsOptions: IOption[] = [
		{ Key: 'A', Value:'All types of rights', },
		{ Key: 'L', Value:'Limited rights as described below', },
	];

	public get successorInInterestBasisCode(): string { return this.getFormDataKey('Claim.SuccessorInInterestBasisCode') }
	public get percentageInterestClaimedCode(): string { return this.getFormDataKey('Claim.PercentageInterestClaimedCode') }
	public get rightCodes(): string { return this.getFormDataKey('Claim.RightCodes') }
	public get typeOfRights(): boolean { return this.getFormDataKey('Claim.TypeOfRights') }

	public async created() {
		this.$store.commit('InterviewModule/updatePageName', 'Claim');
		if (this.$route.params.refreshFormData) {
			await this.$store.dispatch('InterviewModule/getFormData', 'Claim');
		}
		this.isLoading = false;
	}
}
